import * as React from 'react';

// Components
import Badge, { IBadgeProps } from './';

// Style
import './ModifiedBadge.css';

// Component
interface IProps extends IBadgeProps {
}

function ModifiedBadge(props: IProps) {
    return (
        <Badge {...props} classes={{ badge: 'ModifiedBadge__badge' }}/>
    );
}

export default ModifiedBadge;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Badge/ModifiedBadge.tsx